import Feature36 from './Feature36'
export default Feature36
